const ja_JP = {
  "hello": "こんにちわ",
  "App.Footer.noteText": "実際の列車位置と異なる場合があります。",
  "App.Train.significantlyDelayed": "大幅遅れ",
  "App.ModalDialog.headerTitle": "列車情報",
  "App.ModalDialog.cars": "両",
  "App.ModalDialog.currently": "現在地",
  "App.ModalDialog.onTime": "遅れなし",
  "App.ModalDialog.minLate": "分遅れ",
  "App.ModalDialog.significantlyDelayed": "大幅遅れ",
  "App.ModalDialog.trainStops": "停車駅",
  "App.ModalDialog.arrivesScheduled": "到着時刻（定刻）",
  "App.ModalDialog.estimated": "（見込）",
  "App.ModalDialog.doesNotStop": "通過",
  "App.ModalDialog.sorryArrivalTimeNotAvailable": "大変申し訳ございません。\r\n現在、到着時刻を表示できません。",
  "App.ModalDialog.arrivalTimeNotAvailable": "現在、到着時刻を表示できません。",
  "App.ModalDialog.furtherArrivalTimeNotAvailable": "ここから先は、現在到着時刻を表示していません。",
  "App.ModalDialog.kindOrDestinationsMayChange": "※種別・行先等については、変更となる場合がございます。",
  "App.TrainPositions.enableAutoRefresh": "自動更新をONにします",
  "App.TrainPositions.disableAutoRefresh": "自動更新をOFFにします",
  "App.TrainPositions.thruToJR": "埼京線・{br}川越線直通",
  "App.TrainPositions.thruToTokyu": "東横線・目黒線直通",
  "App.TrainPositions.thruToToyoko": "東横線直通",
  "App.TrainPositions.thruToMeguro": "目黒線直通",
  "App.TrainPositions.thruToFukutoshin": "副都心線直通",
  "App.TrainPositions.thruToNambokuMita": "南北線・{br}三田線直通",
  "App.TrainPositions.kindModal.title": "種別凡例",
  "App.TrainPositions.footer.actualMayDiffer": "実際の列車位置・種別・行先・両数・遅延時間と異なる場合があります。",
  "App.TrainPositions.footer.displayTime": "画面表示時刻",
  "App.TrainPositions.dialog.outsideArea": "相鉄線のエリア外です",  
  "App.RouteMap.kindModal.title": "種別凡例",
  "App.RouteMap.kindModal.noteComLtdExpAndComExpStops": "○：通勤特急・通勤急行停車駅",
  "App.RouteMap.kindModal.noteComLtdExpStops": "△：通勤特急は鶴ヶ峰に停車",
  "App.TransferModal.transferRoute": "乗換路線",
  "StationDetail.stationMap": "構内図",
  "StationDetail.stopPositions": "ホーム停車位置",
  "StationDetail.thruToJR": "埼京線・川越線直通",
  "StationDetail.thruToToyoko": "東横線直通",
  "StationDetail.thruToMeguro": "目黒線直通",
  "StationDetail.checkCongestionSituation": "駅の混雑状況を{br}確認できる！",
  "StationDetail.stationView": "ステーションビュー",
  "Timetable.trackNo": "のりば",
  "Timetable.trainKind": "種別",
  "Timetable.destination": "行き先",
  "Timetable.depTime": "発車時刻",
  "Timetable.cars": "両数",
  "TermsDetail.pageTitle": "相鉄線アプリ利用規約",
  "TermsDetail.title": "はじめに",
  "TermsDetail.abstract": "「相鉄線アプリ 利用規約」（以下「本規約」といいます。）は、相模鉄道株式会社（以下「相模鉄道」といいます。）が提供するスマートフォン向けアプリケーション「相鉄線アプリ」（以下「本アプリ」といいます。）の利用者（以下「利用者」といいます。）への提供条件および本アプリの利用に関する利用者と相模鉄道との間の権利義務について定めるものです。",
  "TermsDetail.article1": "第1条 規約の適用",
  "TermsDetail.paragraph1_1": "利用者は、本規約に同意の上、本アプリを利用するものとします。本規約に同意いただけない場合は、本アプリを利用することはできません。",
  "TermsDetail.paragraph1_2": "本規約は、本アプリの提供条件および本アプリの利用に関する利用者と相模鉄道との間の権利義務を定めるものであり、利用者と相模鉄道との間の本アプリの利用に関わる一切の関係に適用されます。",
  "TermsDetail.paragraph1_3": "本規約の内容とその他の本規約外における本アプリの説明等が異なる場合は、本規約の内容が優先して適用されます。",
  "TermsDetail.article2": "第2条 本アプリの目的",
  "TermsDetail.paragraph2_1": "本アプリは、インターネットを通じて、相模鉄道の運行情報や相模鉄道（グループ会社を含みます）のイベント情報等を提供するものです。",
  "TermsDetail.article3": "第3条 利用料金",
  "TermsDetail.paragraph3_1": "本アプリの利用料金は無料です。ただし、本アプリのダウンロードおよび利用に係る通信料は利用者が負担するものとします。",
  "TermsDetail.article4": "第4条 利用環境",
  "TermsDetail.paragraph4_1": "本アプリの利用にあたり必要とされる機器、ソフトウェア、インターネット接続、電話回線等は、利用者が自らの責任と負担で準備するものとします。",
  "TermsDetail.article5": "第5条 知的財産権",
  "TermsDetail.paragraph5_1": "本アプリのコンテンツに関する著作権その他の知的財産権は、全て相模鉄道または相模鉄道が指定する者に帰属します。",
  "TermsDetail.article6": "第6条 本アプリの変更および終了",
  "TermsDetail.paragraph6_1": "相模鉄道は、事前の予告なく、本アプリの全部または一部を変更、追加または削除することができます。",
  "TermsDetail.paragraph6_2": "相模鉄道は、事前の予告なく、本アプリの提供、アップデートを終了することができます。",
  "TermsDetail.article7": "第7条 免責事項",
  "TermsDetail.paragraph7_1": "相模鉄道は、利用者に対し、本アプリが正確に作動することおよびすべての機能が発揮されることについて、保証するものではありません。",
  "TermsDetail.paragraph7_2": "相模鉄道は、本アプリにより提供する情報について、正確な情報を提供することに努めますが、情報の正確性・完全性を保証するものではありません。また、インターネットの特性等により、本アプリ上の情報と実際の情報とに時差等が生じることがあります。",
  "TermsDetail.paragraph7_3": "相模鉄道は、以下のいずれかに該当する場合には、利用者に事前の通知をすることなく、本アプリの全部または一部の提供を停止または中断することができるものとします。",
  "TermsDetail.paragraph7_3_1": "システムの点検または保守を緊急に行う場合",
  "TermsDetail.paragraph7_3_2": "コンピューター、通信回線等が事故や第三者からの攻撃によって停止した場合",
  "TermsDetail.paragraph7_3_3": "地震、落雷、火災等の不可抗力によって本アプリの運営ができなくなった場合",
  "TermsDetail.paragraph7_3_4": "相模鉄道が本アプリの運営に利用する施設等において、電気通信サービスまたはインターネットプロバイダの都合等により通信が不能となった場合",
  "TermsDetail.paragraph7_3_5": "その他、相模鉄道が停止または中断を行う必要があると判断した場合",
  "TermsDetail.paragraph7_4": "相模鉄道は、利用者が本アプリを利用したことまたは本アプリが利用できなかったことに起因して利用者または第三者に生じた損害について、一切の責任を負いません。",
  "TermsDetail.article8": "第8条 禁止事項",
  "TermsDetail.paragraph8_1": "本アプリの利用に際しては、次に定める行為（それらを誘発する行為や準備行為を含みます）を禁止します。",
  "TermsDetail.paragraph8_1_1": "相模鉄道または第三者を装う行為（なりすまし行為）",
  "TermsDetail.paragraph8_1_2": "本アプリにより配信される映像、音声、文字等、ソフトウェア、その他本アプリに関連した情報を著作権法で認められた私的利用の範囲を超えて転載、複写、複製、出版、上映、譲渡、改変、公衆送信、送信可能化し、その他の態様で利用する行為、その他一切の二次利用をする行為",
  "TermsDetail.paragraph8_1_3": "逆コンパイル、逆アセンブル、リバースエンジニアリングによるソースコード、仕組みや仕様を解析または改変する行為",
  "TermsDetail.paragraph8_1_4": "本アプリに係る権利、義務の全部または一部について譲渡、賃貸または第三者に移転する行為",
  "TermsDetail.paragraph8_1_5": "相模鉄道または第三者の通信設備、コンピューターその他の機器およびソフトウェアに不正にアクセスし、またはそれらの利用もしくは運用に支障を与える行為もしくはそのおそれのある行為",
  "TermsDetail.paragraph8_1_6": "相模鉄道または第三者の知的財産権その他の権利を侵害する行為または侵害するおそれのある行為",
  "TermsDetail.paragraph8_1_7": "公序良俗に反する行為、違法行為またはそのおそれのある行為",
  "TermsDetail.paragraph8_1_8": "選挙活動またはこれに類する行為、その他の政治および宗教に関する行為",
  "TermsDetail.paragraph8_1_9": "事実に反する情報またはそのおそれのある情報を相模鉄道、他の利用者または第三者に対して提供する行為",
  "TermsDetail.paragraph8_1_10": "本アプリに関連して営利を目的とする行為またはその準備を目的とする行為",
  "TermsDetail.paragraph8_1_11": "本アプリの提供および運営を妨げ、または誹謗する行為",
  "TermsDetail.paragraph8_1_12": "他の利用者に関する情報を収集したり蓄積したりする行為",
  "TermsDetail.paragraph8_1_13": "本アプリに関連して、次条に規定する反社会的勢力またはこれと密接に関わりのある者に直接・間接に利益を提供する行為",
  "TermsDetail.paragraph8_1_14": "本アプリの運営を妨害する行為または相模鉄道が不適切と判断する行為",
  "TermsDetail.paragraph8_2": "利用者が前項各号の禁止事項に該当する行為を行った場合、相模鉄道は当該利用者による本アプリの利用を停止することがあります。なお、当社は当該利用の停止に関して、一切の責任を負わないものといたします。",
  "TermsDetail.article9": "第9条　反社会的勢力の排除",
  "TermsDetail.paragraph9_1": "利用者は、相模鉄道に対し、自己が暴力団員、暴力団関係企業・団体その他の反社会的勢力またはその関係者ではないことを表明し、保証した上で本アプリを利用するものとします。",
  "TermsDetail.article10": "第10条 履歴情報の取得",
  "TermsDetail.paragraph10_1": "相模鉄道は、本アプリを通じて、携帯端末の個体識別情報（個人及び端末を特定する情報等）を取得することはありません。",
  "TermsDetail.paragraph10_2": "相模鉄道は、利用者から次の情報（以下「履歴情報」といいます。）を収集し、本アプリの改良や利便性の向上、本アプリに関連する新しいサービスの検討、本アプリに関連するコンテンツの推奨（リコメンド）を目的として利用することがあります。",
  "TermsDetail.paragraph10_2_1": "本アプリの利用日時",
  "TermsDetail.paragraph10_2_2": "本アプリの利用方法",
  "TermsDetail.paragraph10_2_3": "本アプリの利用環境（本アプリを利用した位置情報、OS種別およびバージョン、ブラウザ種別、利用モバイル機種、cookieおよびJavascriptがONであること等の情報",
  "TermsDetail.paragraph10_3": "相模鉄道は、履歴情報を統計データに加工し、相鉄グループ各社および協力会社に提供することがあります。",
  "TermsDetail.article11": "第11条　My駅について",
  "TermsDetail.paragraph11_1": "利用者は、本アプリの一部を利用する場合には、My駅に登録しなければなりません。",
  "TermsDetail.paragraph11_2": "My駅に登録した利用者は、いつでもMy駅に登録した情報を変更・削除することができます。",
  "TermsDetail.article12": "第12条 個人情報の取扱い",
  "TermsDetail.paragraph12_1": "利用者が相模鉄道に対して個人情報を提供する場合にあたっての個人情報の取り扱いについては、本規約のほか、相鉄グループウェブサイト上で掲載する「{groupPolicyLink}」が適用されます。",
  "TermsDetail.paragraph12_1_group_policy": "相鉄グループ個人情報保護方針",
  "TermsDetail.paragraph12_2": "相模鉄道は、本規約に定める情報の情報システム管理を外部に委託しており、その際に個人情報を委託先に預託しています。委託先において利用者の個人情報の保護や管理が適切に行われていることを、相模鉄道の責任において監督します。",
  "TermsDetail.paragraph12_3": "第１５条に規定する定期券QR予約システムにおいてご登録いただく個人情報については、サーバIDとSSLによる暗号化通信を利用し、相模鉄道のサーバまで安全に届けられます。なお、スマートフォン、タブレットの使用環境によっては、暗号化されていない個人情報がキャッシュデータとしてスマートフォン、タブレットに保存される場合があります。個人情報をご入力いただいたあとは、特にお取り扱いにご注意下さい。",
  "TermsDetail.article13": "第13条 プッシュ通知機能について",
  "TermsDetail.paragraph13_1": "本アプリは、プッシュ通知機能（本アプリ上で利用者に対しお知らせする必要があるときにアプリ側から自動的に通知する機能）を有します。利用者がプッシュ通知機能を利用する場合は設定画面においてプッシュ通知機能をONにしてください。当該設定は、いつでも変更することができます。",
  "TermsDetail.paragraph13_2": "相模鉄道は、プッシュ通知機能に関する利用者の履歴情報を、第10条第2項に規定する目的で利用することがあります。",
  "TermsDetail.article14": "第14条 Station Viewについて",
  "TermsDetail.paragraph14_1": "本アプリはStation View機能（駅混雑状況の画像配信）を有します。混雑状況の画像データは、個人情報保護の観点から、駅構内に設置しているアプリ専用カメラの画像よりデータ加工技術を用いて解析し、無人の改札口画像（背景画像）に人型アイコンを配置後、匿名情報として相鉄線アプリに配信しています。なお、画像等の保持は一切行いません。",
  "TermsDetail.article15": "第15条 定期券QR予約システムについて",
  "TermsDetail.paragraph15_1": "本アプリは定期券QR予約システム（以下「本サービス」といいます）にリンクしています。本サービスではご予約完了時に相鉄線アプリからプッシュ通知が送られます。ご購入時に必要なQRコードが含まれている為、プッシュ通知が受信可能な設定をした上で、ご利用ください。",
  "TermsDetail.paragraph15_2": "本サービスをご利用のお客様は、定期券新規予約時に表示される注意事項「本サービスご利用にあたって」及び当社公式ホームページ「定期券ご利用案内」の内容に同意したものとみなします。",
  "TermsDetail.article16": "第16条 対象OS",
  "TermsDetail.paragraph16_1": "相鉄線アプリに対象となるOSは以下の通りといたします。なお、対象OSでも一部動作しない場合があります。",
  "TermsDetail.paragraph16_1_ios": "iOS　10以上",
  "TermsDetail.paragraph16_1_android": "Android　5以上",
  "TermsDetail.article17": "第17条 本規約の変更",
  "TermsDetail.paragraph17_1": "相模鉄道は、本規約の内容を利用者の承諾なしに予告なく変更することができます。この場合、相模鉄道は、その旨を本アプリの画面上に表示します。表示後に利用者が本アプリを利用することにより、利用者は、変更後の規約に同意したものとみなします。利用者が変更後の本規約に同意できない場合は、直ちに本アプリの利用を停止しなければなりません。",
  "TermsDetail.article18": "第18条 準拠法および合意管轄",
  "TermsDetail.paragraph18_1": "本アプリの利用、本規約の解釈は、日本国法に準拠します。本アプリの利用に関して生じた訴訟については、横浜地方裁判所を第一審の専属的合意管轄裁判所とします。",
  "TermsDetail.signatureName": "相模鉄道株式会社",
  "TermsDetail.signatureDate": "2020年3月18日（改版）",
  "ContactDetail.title": "相鉄に関するお問い合わせやご意見・ご要望は",
  "ContactDetail.body1": "「相鉄お客様センター」",
  "ContactDetail.body2": "TEL 045-319-2111 9:00〜19:00（土・日・祝日は9:00〜17:00、12月30日から1月3日は休業）",
  "ContactDetail.body3": "FAX 045-319-2191",
  "ContactDetail.footer1": "詳細につきましては",
  "ContactDetail.footerHere": "こちら",
  "ContactDetail.footer2": "からご確認ください。",

  // titles for navite app
  "PageTitle.StationDetail": '駅情報',
  "PageTitle.StationView": 'Station View',
  "PageTitle.TrainPositions": '列車走行位置',
  "PageTitle.RouteMap": '路線図',
}

export default ja_JP
